<script>
import {defineComponent} from "vue";
import featureMixin from "@/mixins/featureMixin";
import WishListApi from "@/features/wishlist/api/WishListApi";
import {FLYER_EVENT_BEFORE_SETUP, FLYER_EVENT_LOADED} from "@/classes/FlyerEvents";
import {mapActions, mapGetters} from "vuex";
import BlockGen from "@/features/triangle-rewards/classes/BlockGen";
import WishListCard from "@/features/wishlist/WishListCard.vue";
import Page from "@/classes/Page";
import {calcCols} from "@/features/wishlist/WishListHelpers";

let api;
export default defineComponent({
	name: "WishList",
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'wishlist',
			featureEvents: [FLYER_EVENT_LOADED, FLYER_EVENT_BEFORE_SETUP],
			loaded: false
		}
	},
	computed: {
		...mapGetters(['storeId']),
		...mapGetters('scale', ['defPageGrid', 'defPage']),
		...mapGetters('wishListStore', ['userId', 'prodCodes', 'userFirstName', 'cols', 'products']),
		...mapGetters('landingPage', ['currentFlyer']),
		perPage() {
			return this.config?.perPage || 7;
		}
	},
	methods: {
		...mapActions(['injectPage', 'setLoadingState']),
		...mapActions('wishListStore', ['setProducts', 'setConfig']),
		async loadWishList() {
			console.log("Load Wish List");
			api = new WishListApi(this.config?.api);
			const prods = await api.getProducts(this.userId, this.storeId, `${this.language}_CA`, this.prodCodes);
			this.setProducts(prods);
			console.log('WishList Prods:', prods);
		},
		async onFeatureEvent(event, data) {
			switch (event) {
				case FLYER_EVENT_LOADED:
					console.log(data);
					//await this.loadWishList(data)
					break;
				case FLYER_EVENT_BEFORE_SETUP:
					this.setConfig(this.config);
					this.injectWishList();
					break;
			}
		},
		injectWishList() {

			if(!this.userId || !this.storeId || !this.prodCodes?.length || !this.config.enabled) return;
			// eslint-disable-next-line no-unused-vars
			this.injectPage((pages, pagesIndex, unitWidth, unitHeight, language) => {
				this.setLoadingState(true);
				return new Promise((resolve, reject) => {
					this.loadWishList().then(() => {
						if (this.products.length === 0) {
							reject('No WishList Products');
							return;
						}
						let c = 0;
						let pp = this.perPage;
						let grid = this.defPage.grids;
						//console.log('WishList config.pageNum: ', this.config.pageNum);
						//console.log('WishList pagesIndex:', pagesIndex[this.config.pageNum], pagesIndex);
						let pageNum = pagesIndex[this.config.pageNum] ? this.config.pageNum: Object.keys(pagesIndex).reduce((acc, current) => Math.max(acc,current)) ;
						//console.log('WishList PageNum:', pageNum);
						for (let i = 0; i < this.products.length; i += pp) {
							const products = this.products.slice(i, i + pp);
							const cols = calcCols(products.length);
							const blocks = BlockGen.GenBlock(cols, 4, unitWidth, unitHeight, {}, {id: 'wish_list', type: 'component', component: WishListCard, props: {products}})
							const page = Page.GenPage('WishList', unitWidth, unitHeight, Object.assign({}, grid,
								{
									desktop: {
										rowCount: 4, colCount: cols
									}
								}), [blocks]);
							pages.splice(pagesIndex[pageNum] + c++, 0, page);
						}

						//console.log('Injecting WishList', page);
						resolve();
					}).finally(() => {
						this.setLoadingState(false);
					}).catch(reject)

				})

			})
		}
	}

});
</script>

<template>
	<div class="wish-list"></div>
</template>

<style lang="scss" scoped>
.wish-list {
  display: none;
}

</style>
<style lang="scss">
[flyer-orientation='vertical'] .section-container[page-id='WishList'] {
  grid-template-rows: auto !important;
}

[flyer-orientation="vertical"] .section-container[page-id="WishList"]:nth-child(n+2 of .section-container[page-id="WishList"]) {
  display: none !important;
}


</style>
